import { render, staticRenderFns } from "./FolderSettingsDomain.vue?vue&type=template&id=5f5bed02"
import script from "./FolderSettingsDomain.vue?vue&type=script&lang=js"
export * from "./FolderSettingsDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports